import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { DrawerItems } from '@/components/Drawer/Drawer.styles';

export const AdFormCategories = styled(DrawerItems)`
  border-top: 0;
`;

export const AdFormPhoneMsgBox = styled.div`
  padding: 0 15px;
  margin: 0 0 25px;
`;

export const AdFormPhoneMsg = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const AdFormPhoneMsgInBox = styled(Typography.Title)`
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.system.lightBlue};
  padding: 15px;
  margin-top: 10px;
`;

export const AdFormSubmitBox = styled.div`
  padding: 0 15px 25px;
`;

export const AdFormTextareaBox = styled(DrawerItems)`
  padding: 15px;
`;

export const AdFormImagesBox = styled(DrawerItems)`
  padding: 15px;
`;

export const AdFormMsg = styled(Typography.Caption)`
  margin-top: 10px;
  text-align: center;
  color: ${({ theme }) => theme.palette.tertiary.labels};

  a {
    text-decoration: underline;
  }
`;
